module.exports = __webpack_public_path__ + "static/img/icon4-10.35ea826f.png";